import { UUID } from '../../../../../types';
import { FiltersProps } from '../../../../../helpers/filters/hooks/useFilters';

import { useTeamsFilter } from './hooks/useTeamsFilter';

import { AlertMessage } from '../../../../../helpers/AlertMessage';
import { LoadingSkeleton } from '../../../../../helpers/LoadingSkeleton';
import { MultiSelectFilter } from '../../../../../helpers/filters/MultiSelectFilter';

import { teamsKeys } from '../../../../../locales/keys';

interface TeamsFilterProps extends FiltersProps<UUID[]> {
  teamType: string;
}

function TeamsFilter({ name, onChange, teamType, value }: TeamsFilterProps) {
  const {
    selectedTeamsFetched,
    data,
    handleFilterTeams,
    teamsLoading,
    selectedValue,
    errorMessage
  } = useTeamsFilter({ teamType, value });

  return (
    <LoadingSkeleton count={2} loaded={selectedTeamsFetched}>
      <MultiSelectFilter
        data={data}
        i18nPlaceholder={teamsKeys.selectCompanies}
        name={name}
        onChange={onChange}
        onInputChange={handleFilterTeams}
        optionsLoading={teamsLoading}
        selectedValue={selectedValue}
        value={value}
      />
      <AlertMessage addClassName="mt-2" message={errorMessage} />
    </LoadingSkeleton>
  );
}

export default TeamsFilter;
